import { Typography, Drawer, Box, IconButton } from '@mui/material';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import ClearIcon from '@mui/icons-material/Clear';
import {
	DrawerBenefitContainerSX,
	DrawerBenefitContentSX,
	DrawerBenefitHeaderSX,
	DrawerBenefitHeaderTitleSX,
} from '@/components/blocks/DpDrawer/styles';

interface DpDrawerProps {
	open: boolean;
	title: React.ReactNode;
	hideCloseButton?: boolean;
	children: React.ReactNode;
	onClose: () => void;
	onApply?: () => void;
}

export const DpDrawer: React.FC<DpDrawerProps> = ({
	open,
	title,
	children,
	hideCloseButton = false,
	onClose,
	onApply,
}) => (
	<Drawer
		anchor="bottom"
		open={open}
		keepMounted
		sx={DrawerBenefitContainerSX}
		onClose={onClose}
		// ESTO ESTA INTENTANDO SOBREESCRIBIR EL ESTILO DE MUI DE LA ANIMACION DE LA BARRA DE FONDO YA QUE ESTA DEPRECADO
		BackdropProps={{
			sx: {
				animationDuration: '0.3s !important',
				transitionDuration: '0.3s !important',
				transition: 'background-color 0.3s ease-in-out, opacity 0.3s ease-in-out !important',
				animation: 'ease-in-out !important',
				transform: 'background-color 0.3s ease-in-out, opacity 0.3s ease-in-out !important',
			},
		}}
	>
		<Box
			sx={{
				position: 'sticky',
				top: '1px',
				...(onApply && {
					height: 'calc(100dvh - 190px)',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
				}),
			}}
		>
			<Box sx={DrawerBenefitContentSX}>
				{!hideCloseButton ? (
					<Box sx={{ position: 'absolute', top: 0, right: 0 }}>
						<IconButton
							color="inherit"
							onClick={onClose}
							sx={{
								'&:hover': {
									backgroundColor: 'transparent',
									color: 'inherit',
								},
								padding: '16px 14px',
								zIndex: 10000,
							}}
						>
							<ClearIcon color="inherit" fontSize="inherit" />
						</IconButton>
					</Box>
				) : null}

				<Box sx={DrawerBenefitHeaderSX}>
					<Typography sx={DrawerBenefitHeaderTitleSX}>{title}</Typography>
				</Box>
			</Box>

			<Box
				px={2}
				sx={{
					flex: onApply ? 1 : undefined,
					maxHeight: {
						xs: '63dvh',
						'@media (min-width: 390px)': {
							maxHeight: '68dvh',
						},
					},
					overflow: 'auto',
				}}
			>
				{children}
			</Box>
			{onApply ? (
				<Box
					sx={{
						padding: '16px 20px',
						backgroundColor: 'white',
						borderTop: '1px solid #E0E0E0',
						flexShrink: 0,
					}}
				>
					<DpButton variant="primary" fullWidth onClick={onApply}>
						{'Aplicar filtros'}
					</DpButton>
				</Box>
			) : null}
		</Box>
	</Drawer>
);
